import { ParamsNew, WithdrawToParentType } from 'app/dataTypes/cafeteria/compensation/withdraw/toParent'

import type { Request } from '../../../../index'


type ParamsApi = {
  student_id: number
  food_supplier_id: number
}

export const convertParams = ({
  studentID,
  supplierID,
}: ParamsNew): [ParamsApi, null] => {
  return [{
    student_id: parseInt(studentID, 10),
    food_supplier_id: parseInt(supplierID, 10),
  }, null]
}

type NewWithdrawToParentApi = {
  result: 'success'
  order_data: {
    student_fullname: string
    parent_fullname: string
    school_title: string
    klass_title: string
    bank_title: string
    bik: string
    checking_account: string // р/с
    corr_account: string // к/с
  },
  available_withdraw_value: number
}

export const convertResult = (data: NewWithdrawToParentApi): WithdrawToParentType => {
  const { available_withdraw_value: availableWithdrawValue, order_data: orderData } = data
  const {
    student_fullname: studentFullname,
    parent_fullname: parentFullname,
    school_title: schoolTitle,
    klass_title: classTitle,
    bank_title: bankTitle,
    bik,
    checking_account: checkingAccount,
    corr_account: corrAccount,
  } = orderData

  return {
    availableWithdrawValue,
    studentFullname,
    schoolTitle,
    classTitle,
    parentFullname,
    parentPhone: '',
    parentAddress: '',
    bankTitle,
    bik,
    checkingAccount,
    corrAccount,
  }
}

export const GET_COMPENSATION_WITHDRAW_ORDERS_NEW: Request<ParamsNew, WithdrawToParentType, void> = [
  'cabinet/compensation/withdraw_orders/new',
  'get',
  ['data'],
]
